export function replaceNbsps(str: string): string {
  return str.replace(/\u00a0/g, ' ');
}

export function validateUrl(url: string | undefined): boolean {
  if (!url || !/^https?:\/\//i.test(url)) return false;

  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
}

export const escapeRegex = (string: string): string => string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');

/** Replaces the final whitespace with a non-breaking space to prevent single words handging in the final line of text. */
export const preventOrphans = (text: string): string => text.trim().replace(/^(.+)\s(\S*)$/, '$1\u00a0$2');

export const shortenName = (name: string): string =>
  name
    .split(' ')
    .map((slice) => (slice.length ? String(slice[0]).toUpperCase() : ''))
    .join('')
    .slice(0, 2);

export const camelCaseToUpperUnderscoreCase = (str: string): string => {
  return str.replace(/([a-z])([A-Z])/g, '$1_$2').toUpperCase();
};

export const getShortenedText = (text: string, maxLength: number): string => {
  if (!text) return '';

  if (text?.length < maxLength) {
    return text;
  } else {
    return `${text?.slice(0, maxLength)}...`;
  }
};
